import React from "react";
import styled from "styled-components";
import SkeletonLoader from "./SkeletonLoader";

const HeaderMetrics = ({
  type = "",
  likes = 0,
  points = 0,
  labelLikes = "Puntos",
  labelPoints = "Ñamis",
  loaderLikes = false,
  loaderPoints = false,
  showPoints = true,
  showNiamPoinst = true,
  className = "",
}) => {
  const safeLikes = Number.isFinite(Number(likes)) ? Number(likes) : 0;
  const safePoints = Number.isFinite(Number(points)) ? Number(points) : 0;
  return (
    <Metrics className={className}>
      {showPoints && (
        <Likes>
          <Count>
            <SkeletonLoader active={loaderLikes} width="60px" height="10px">
              <LikeText>{labelLikes}</LikeText>
            </SkeletonLoader>
            <SkeletonLoader active={loaderLikes} width="80px" height="30px">
              <CountContainer>
                <ValueIcon />
                <ValuePoints>{safeLikes}</ValuePoints>
              </CountContainer>
            </SkeletonLoader>
          </Count>
        </Likes>
      )}

      <Spacer />

      {showNiamPoinst && (
        <Points>
          <Count>
            <SkeletonLoader active={loaderPoints} width="60px" height="10px">
              <LikeText>{labelPoints}</LikeText>
            </SkeletonLoader>
            <SkeletonLoader active={loaderPoints} width="80px" height="30px">
              <CountContainer>
                <ValuePoints>{safePoints}</ValuePoints>
              </CountContainer>
            </SkeletonLoader>
          </Count>
        </Points>
      )}
    </Metrics>
  );
};

export default HeaderMetrics;

const Metrics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  background-color: white;
  padding: 0;
`;

const Likes = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
`;

const Points = styled(Likes)`
  justify-content: flex-end;
`;

const Spacer = styled.div``;

const LikeText = styled.p`
  font-weight: 600;
  font-size: 14px;
  color: #afafaf;
  margin: 0;
`;

const Count = styled.div`
  width: 100%;
  position: relative;
`;

const CountContainer = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: auto auto;
  gap: 5px;
`;

const ValuePoints = styled.div`
  font-size: 14px;
  margin: 0;
  font-weight: 500;
`;

const ValueIcon = styled.div``;
